export default "__VITE_ASSET__BQm56sip__"